import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll para o topo sempre que a rota mudar
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // Scroll suave
        });
    }, [pathname]);

    // Scroll para o topo quando o componente montar (primeira carga)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return null; // Este componente não renderiza nada
};

export default ScrollToTop;
